import port1 from '../img/portImages/maya-1.JPG';
import port2 from '../img/portImages/port1.jpg';
import port3 from '../img/portImages/Basics Computer Application Certificate.JPG';
// import port4 from '../img/portImages/port3.jpg';
// import port6 from '../img/portImages/port5.jpg';
// import port7 from '../img/portImages/port6.jpg';
import dm1 from '../img/portImages/Fundamentals of Digital marketing.png';

const portfolios = [
    {
        id: 1,
        category: 'Android',
        link1: 'www.youtube.com',
        link2: 'www.github.com',
        icon1: 'G',
        icon2: 'Y',
        image: port1,
        title: 'Android App Development',
        title2: 'I have completed the Android app development course from National Computer Training and Research Academy. The duration of this course was one month'
    },
    {
        id: 2,
        category: 'Digital Marketing',
        link1: 'www.youtube.com',
        link2: 'www.github.com',
        icon1: 'G',
        icon2: 'Y',
        image: port2,
        title: 'Content Writing Masterclass',
        title2: 'I have completed the Content Writing Masterclass from Three Phase Academy. The duration of this course was one month'
    },
    {
        id: 8,
        category: 'Digital Marketing',
        link1: 'www.youtube.com',
        link2: 'www.github.com',
        icon1: 'G',
        icon2: 'Y',
        image: dm1,
        title: 'Fundamentals of Digital Marketing',
        title2: 'I have completed the Fundamentals of Digital Marketing from Google Digital Grage. The duration of this course was one month'
    },
    {
        id: 3,
        category: 'Office',
        link1: 'www.youtube.com',
        link2: 'www.github.com',
        icon1: 'G',
        icon2: 'Y',
        image: port3,
        title: 'Basics Computer Application',
        title2: 'I have completed the Basics Computer Application course from National Computer Training and Research Academy. The duration of this course was one month'
    }
]

export default portfolios;